<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="hotels-content">
                                <div class="lds-ring" v-if="!isLoad">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="hotel-inner hotel-inner__additional" v-if="isLoad">
                                    <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                    <form>
                                        <h2>Additional</h2>
                                        <div class="hotel-item">
                                            <div class="hotel-subtitle">Minimum Nights Stay</div>
                                            <div class="hotels-seasons-item" v-for="(item, index) in nights"
                                                 :key="index">
                                                <div class="form-control-datepicker form-control-datepicker--labeled">
                                                    <div :class="['form-control-group', { 'is-error' : item.error }]">
                                                        <span class="form-control-label">Valid From</span>
                                                        <div class="form-control-wrap">
                                                            <input type="text" Placeholder="Date From"
                                                                   :value="item.dateFrom"
                                                                   @focus="item.error = false;isEdit = true"
                                                                   @blur="item.dateFrom = $event.target.value"
                                                                   class="form-control js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div :class="['form-control-group', { 'is-error' : item.error }]">
                                                <span class="form-control-label">Valid
                                                    To</span>
                                                        <div class="form-control-wrap">
                                                            <input type="text" Placeholder="Date To"
                                                                   :value="item.dateTo"
                                                                   @focus="item.error = false;isEdit = true"
                                                                   @blur="item.dateTo = $event.target.value"
                                                                   class="form-control js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    :class="['form-control-group form-control-group--time form-control-group--time_half is-active', { 'is-error' : item.error }]">
                                                <span class="form-control-label">Min
                                                Nights</span>
                                                    <div class="form-control-wrap">
                                                        <input type="number" v-model.number="item.minNights"
                                                               @focus="item.error = false;isEdit = true"
                                                               class="form-control">
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                                entity: 'Minimum nights stay',
                                                name: 'this',
                                                handler: removeNight,
                                                id: index
                                            })">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn--rounded2 btn--green"
                                                    @click="addNight();isEdit = true">
                                                <span>Add Season</span></button>
                                            <div class="edit-rooms__btn-edit">
                                                <button type="button" class="btn btn--green"
                                                        @click="updatePopup = 'nights'"><span>Update</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="hotel-item">
                                            <div class="hotel-subtitle">Hotel closed during</div>
                                            <div class="hotels-seasons-item" v-for="(item, index) in during"
                                                 :key="index">
                                                <div class="form-control-datepicker form-control-datepicker--labeled">
                                                    <div :class="['form-control-group', { 'is-error' : item.error }]">
                                                <span class="form-control-label">Closed
                                                    From</span>
                                                        <div class="form-control-wrap">
                                                            <input type="text" Placeholder="Date From"
                                                                   @focus="item.error = false;isEdit = true"
                                                                   v-model="item.dateFrom"
                                                                   @blur="item.dateFrom = $event.target.value"
                                                                   class="form-control js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div :class="['form-control-group', { 'is-error' : item.error }]">
                                                <span class="form-control-label">Closed
                                                    To</span>
                                                        <div class="form-control-wrap">
                                                            <input type="text" Placeholder="Date To"
                                                                   @focus="item.error = false;isEdit = true"
                                                                   v-model="item.dateTo"
                                                                   @blur="item.dateTo = $event.target.value"
                                                                   class="form-control js-datepicker-single">
                                                            <div class="form-control-icon">
                                                                <svg width="1em" height="1em"
                                                                     class="icon icon-calendar ">
                                                                    <use
                                                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                                entity: 'Hotel closed during',
                                                name: 'this',
                                                handler: removeDuring,
                                                id: index
                                            })">
                                                    <svg width="1em" height="1em" class="icon icon-close ">
                                                        <use
                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                                    </svg>
                                                </button>
                                            </div>
                                            <button type="button" class="btn btn--rounded2 btn--green"
                                                    @click="addDuring();isEdit = true">
                                                <span>Add Season</span></button>
                                            <div class="edit-rooms__btn-edit">
                                                <button type="button" class="btn btn--green"
                                                        @click="updatePopup = true"><span>Update</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="updatePopup">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--history">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title">
                                            Update History
                                        </div>
                                        <div class="edit-popup__close" @click="updatePopup = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="form-control-group"><span
                                            class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                                            <div class="form-control-wrap">
                                                <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                            </div>
                                          <div class="edit-popup__error-text">
                                            <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                          </div>
                                        </div>
                                        <div class="options-additional__btns">
                                            <button type="button" class="btn btn--silver" @click="updatePopup = false">
                                                <span>Cancel</span>
                                            </button>
                                            <button type="submit" class="btn btn--green edit-popup__submit"
                                                    :disabled="descriptionUpdate.length < 6"
                                                    @click="saveAll()">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>

import Lightpick from 'lightpick'

import {
    getHotelsNights,
    getHotelsDuring,
    updateHotelsNights,
    updateHotelsDuring,
    getHotelAdvanced
} from '@/utilites/api'

import {
    date
} from '@/utilites/functions'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
    data() {
        return {
            nights: [],
            during: [],
            isLoad: false,
            updatePopup: false,
            isEdit: false,
            descriptionUpdate: '',
            hotelName: ''
        }
    },
    props: ['user'],
    components: {HotelsSideMenu, Lightpick},
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id)
            .then(res => {
                this.hotelName = res.names.EN
            })
    },
    methods: {
        checkErrorsNights() {
            let error = false
            this.nights = this.nights.map(item => {
                if (!item.dateFrom || !item.dateTo || (item.minNights < 2 || item.minNights > 7)) {
                    error = true
                    return ({...item, error: true})
                }
                return item
            })
            return error
        },
        checkErrorsDuring() {
            let error = false
            this.during = this.during.map(item => {
                if (!item.dateFrom || !item.dateTo) {
                    error = true
                    return ({...item, error: true})
                }
                return item
            })
            return error
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                      datePicker.hide()
                    })
                });
            }, 1000)
        },
        updateData() {
            const id = this.$route.params.id
            if (id === 'add') {
                this.isEdit = true
            } else {
                this.isEdit = false
            }
            Promise.all([getHotelsNights(id), getHotelsDuring(id)])
                .then(res => {
                    this.nights = res[0].map(item => ({
                        ...item,
                        dateFrom: date(item.dateFrom, 'fromStart'),
                        dateTo: date(item.dateTo, 'fromStart')
                    }))
                    this.during = res[1].map(item => ({
                        ...item,
                        dateFrom: date(item.dateFrom, 'fromStart'),
                        dateTo: date(item.dateTo, 'fromStart')
                    }))
                    this.isLoad = true
                })
        },
        addNight() {
            this.nights = this.nights.concat({
                hotelId: +this.$route.params.id,
                dateFrom: '',
                dateTo: '',
                minNights: ''
            })
        },
        removeNight(index) {
            this.nights = this.nights.filter((item, i) => !(i === index))
            this.isEdit = false
        },
        addDuring() {
            this.during = this.during.concat({
                hotelId: +this.$route.params.id,
                dateFrom: '',
                dateTo: '',
            })
        },
        removeDuring(index) {
            this.during = this.during.filter((item, i) => !(i === index))
            this.isEdit = false
        },
        updateHotelsNightsHandler() {
            if (!this.checkErrorsNights()) {
                updateHotelsNights({
                    seasons: this.nights.map(item => ({
                        ...item,
                        dateFrom: date(item.dateFrom, 'start'),
                        dateTo: date(item.dateTo, 'start')
                    })),
                    history: {
                        hotelId: +this.$route.params.id,
                        userId: this.user.data.id,
                        description: this.descriptionUpdate
                    }
                }, this.$route.params.id)
                    .then(res => {
                        this.$emit('confirmed')
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                        this.isEdit = false
                    })
                    .catch(error => {
                        this.$emit('errored', {text: 'Crosses of periods are detected'})
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                        this.isEdit = false
                    })
            } else {
                this.descriptionUpdate = ''
                this.updatePopup = false
            }
        },
        updateHotelsDuringHandler() {
            if (!this.checkErrorsDuring()) {
                updateHotelsDuring({
                    seasons: this.during.map(item => ({
                        ...item,
                        dateFrom: date(item.dateFrom, 'start'),
                        dateTo: date(item.dateTo, 'start')
                    })),
                    history: {
                        hotelId: +this.$route.params.id,
                        userId: this.user.data.id,
                        description: this.descriptionUpdate
                    }
                }, this.$route.params.id)
                    .then(res => {
                        this.$emit('confirmed')
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                        this.isEdit = false
                    })
                    .catch(error => {
                        this.$emit('errored', {text: 'Crosses of periods are detected'})
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                        this.isEdit = false
                    })
            } else {
                this.descriptionUpdate = ''
                this.updatePopup = false
            }
        },

        saveAll() {
            this.updateHotelsNightsHandler();
            this.updateHotelsDuringHandler();
        },
        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    mounted() {
        this.updateDatePickers()
        this.updateData()
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
        nights() {
            this.updateDatePickers()
        },
        during() {
            this.updateDatePickers()
        }
    }
}
</script>
